<template>
  <div
    id="another-account-block"
    class="d-flex justify-space-around">
    <div
      v-if="userEmail"
      class="account-name text-truncate">
      {{ accountLabel }}: {{ userEmail }}.
    </div>
    <div
      class="qx-link"
      @click.prevent="handleUseAnotherAccount">
      {{ accountText }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AnotherAccount',
  data() {
    return {
      accountLabel: this.$gettext('Account'),
      accountText: this.$gettext('Use another account') + '?',
    };
  },
  computed: {
    ...mapState({
      userEmail: (state) => state.auth.userEmail,
    }),
  },
  methods: {
    ...mapActions({
      logout: 'logout',
      resetStore: 'resetStore',
    }),
    async handleUseAnotherAccount() {
      await this.logout();
      this.resetStore();
    },
  },
};
</script>

<style lang="scss" scoped>
#another-account-block {
  color: $gray-800;
  max-width: 100%;
  .account-name {
    flex: 1;
    line-height: 20px;
    margin-right: 5px;
  }
  .qx-link {
    min-width: 150px;
  }
}
</style>
